export default "__VITE_ASSET__UxkwKUwOh852RmDazYPIzQ__"